import { FeatureFlag, useFeatureFlags } from 'featureFlags';
import { getAppRegion } from 'utils/getAppRegion';

export const useIntegrationsCheck = (): {
  areAccountIntegrationsEnabled: boolean;
  areIntegrationsEnabled: boolean;
} => {
  const {
    [FeatureFlag.DmsIntegrationBox]: isBoxIntegrationEnabled,
    [FeatureFlag.DmsIntegrationDropbox]: isDropboxIntegrationEnabled,
    [FeatureFlag.DmsIntegrationEgnyte]: isEgnyteIntegrationEnabled,
    [FeatureFlag.DmsIntegrationGoogleDrive]: isGoogleDriveIntegrationEnabled,
    [FeatureFlag.DmsIntegrationOneDrive]: isOneDriveIntegrationEnabled,
    [FeatureFlag.DmsIntegrationSharePoint]: isSharePointIntegrationEnabled,
    [FeatureFlag.DmsRegions]: dmsEnabledRegions,
    [FeatureFlag.ManageAccountIntegrations]: isAccountIntegrationsEnabled,
  } = useFeatureFlags();

  const isSomeIntegrationEnabled =
    isBoxIntegrationEnabled ||
    isDropboxIntegrationEnabled ||
    isEgnyteIntegrationEnabled ||
    isGoogleDriveIntegrationEnabled ||
    isOneDriveIntegrationEnabled ||
    isSharePointIntegrationEnabled;

  const areIntegrationsEnabled =
    isSomeIntegrationEnabled &&
    typeof dmsEnabledRegions !== 'boolean' &&
    dmsEnabledRegions.includes(getAppRegion());

  const areAccountIntegrationsEnabled =
    isAccountIntegrationsEnabled &&
    typeof dmsEnabledRegions !== 'boolean' &&
    dmsEnabledRegions.includes(getAppRegion());

  return { areAccountIntegrationsEnabled, areIntegrationsEnabled };
};
